"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
// @ts-nocheck
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const react_table_1 = require("react-table");
const util_1 = require("@app/util");
const _ui_1 = require("@ui");
const store_1 = require("@app/store");
const useRememberTableConfig_1 = require("@app/util/hooks/useRememberTableConfig");
const sort_locale_1 = require("@app/util/sort-locale");
const units_1 = require("@app/util/units");
const use_workspace_table_config_1 = require("@app/util/use-workspace-table-config");
const components_1 = require("./components");
const Filter_1 = require("./components/Filter");
const helpers_1 = require("./helpers");
require("./style.scss");
const SIZE = {
    SLIM: 'table-slim',
    REGULAR: 'table-regular',
};
const TYPES = {
    LEAN: 'lean',
    FILL: 'fill',
};
const Table = ({ rows: data, extraButtonContent, extraContent, extraContentRow, paginationRowExtra, pagination, handleOnSelect, handleOnFilteredRows, tableName, tableConfig, tableRowConfig, isLoading, className, exportHidden, exportFileName, m, customNoDataText, onTableSave, onBatchActions, batchActionsDisabled, bordered, size, extraRow, initialSortBy, initialColumnFilters, initialHiddenColumns, handleDisabledSubmit, showActionBar, showConfig, showSelection, actionBarRef, type, maxHeight, savingLoading, loadingData, rowOnMouseLeave, }) => {
    const [editedRows, setRows] = (0, react_1.useState)([]);
    const [tableData, setTableData] = (0, react_1.useState)([]);
    const tablesConfig = (0, store_1.useRootSelector)((state) => state.tablesConfig);
    const locale = (0, store_1.useRootSelector)((state) => state.locale);
    const tableUserConfig = (0, use_workspace_table_config_1.useWorkspaceTableConfig)(tableName);
    const rememberTableUserConfig = (0, useRememberTableConfig_1.useRememberTableConfig)(tableName);
    const savedHiddenColumns = tableUserConfig?.hiddenColumns;
    const [initHiddenCols, setInitHiddenCols] = (0, react_1.useState)(savedHiddenColumns ?? initialHiddenColumns);
    const savedSortBy = tableUserConfig?.sortBy;
    const [initSortBy, setInitSortBy] = (0, react_1.useState)(savedSortBy ?? initialSortBy);
    const savedFilters = tableUserConfig?.filters;
    const tableColumnKeys = tableConfig.map((column) => column.key);
    const deduplicateFilterValues = (value) => {
        if (!Array.isArray(value))
            return value;
        const uniqueValues = [];
        value.forEach((item) => {
            if (item === null || item === '')
                return;
            if (!uniqueValues.some((existingItem) => existingItem === item)) {
                uniqueValues.push(item);
            }
        });
        return uniqueValues;
    };
    const removeEmptyFilters = (sourceFilters = []) => sourceFilters?.filter((filter) => {
        if (filter.value === null || filter.value === '')
            return false;
        if (Array.isArray(filter.value))
            return filter.value.length > 0;
        return true;
    }) ?? [];
    const sanitizeFilters = (sourceFilters = []) => removeEmptyFilters(sourceFilters)
        ?.map((filter) => ({
        ...filter,
        value: deduplicateFilterValues(filter.value),
    }))
        .filter((filter) => tableColumnKeys.includes(filter.id) &&
        !(Array.isArray(filter.value) && !filter.value.length)) ?? [];
    // filters the caller passes (e.g. from a link that opens the page pre-filtered) beat the remembered
    // ones, and last only for this visit: while they are in play, filters aren't remembered at all
    const [hasCallerFilters] = react_1.default.useState(!!initialColumnFilters?.length);
    const [initFilters] = react_1.default.useState(sanitizeFilters(hasCallerFilters ? initialColumnFilters : (savedFilters ?? [])));
    const defaultActionBarRef = (0, react_1.useRef)(null);
    const tableRef = (0, react_1.useRef)(null);
    const getTransformedColumns = (0, react_1.useMemo)(() => tableConfig.map((column) => {
        const sortFunction = (rowA, rowB) => {
            if ((0, util_1.isDefined)(column.sortFunction)) {
                return column.sortFunction(rowA.original, rowB.original);
            }
            if (!(0, util_1.isValue)(column.rowToStr))
                return 0;
            return (0, sort_locale_1.sortLocale)(column.rowToStr(rowA.original)?.toString(), column.rowToStr(rowB.original)?.toString(), locale);
        };
        const filterFunction = (rows, columnIds, filterValue) => {
            const toStringValue = (value) => value === null || typeof value === 'undefined' ? '' : value.toString();
            return (rows?.filter((row) => filterValue?.some((el) => {
                const rowItem = column.rowToFilterType
                    ? column.rowToFilterType(row.original)
                    : column.rowToStr(row.original);
                if (typeof rowItem === 'string' ||
                    typeof rowItem === 'number' ||
                    typeof rowItem === 'boolean') {
                    if (column.filterExact === true || !(0, util_1.isValue)(column.filterExact)) {
                        return rowItem === el;
                    }
                    return toStringValue(rowItem).includes(toStringValue(el));
                }
                else if (Array.isArray(rowItem)) {
                    return rowItem?.some((item) => item.value === el);
                }
                else {
                    return rowItem && rowItem.value === el;
                }
            })) ?? []);
        };
        // column.width cannot accept anything other than number otherwise it will break
        if (typeof column.minWidth === 'string' ||
            typeof column.maxWidth === 'string' ||
            typeof column.width === 'string') {
            throw new TypeError('column minWidth/maxWidth/width cannot be of type string');
        }
        const widthAdjustment = column.groupBorder
            ? (size = SIZE.SLIM ? 1 : 1.25)
            : 0;
        const defaultWidth = (0, units_1.getRem)(8.75 + widthAdjustment);
        return {
            accessor: column.key,
            disableSortBy: !column.sortable,
            toggleHidden: true,
            minWidth: column.minWidth ?? defaultWidth,
            maxWidth: column.maxWidth,
            width: column.width ?? defaultWidth,
            sortType: !!column.sortable && !!sortFunction ? sortFunction : () => { },
            filter: filterFunction ?? (() => 0),
            Filter: column.filterable
                ? ({ ...props }) => {
                    return (react_1.default.createElement(Filter_1.Filter, { configColumn: column, handleOnFilteredRows: handleOnFilteredRows, ...props }));
                }
                : null,
            ...column,
        };
    }), [tableConfig]);
    const memoizedData = (0, react_1.useMemo)(() => data || [], [data]);
    const defaultColumn = (0, react_1.useMemo)(() => ({ Filter: null }), []);
    const { getTableProps, selectedFlatRows, headerGroups, rows, prepareRow, page, allColumns, gotoPage, canPreviousPage, previousPage, nextPage, canNextPage, pageCount, pageOptions, setPageSize, setAllFilters, setHiddenColumns, state: { pageIndex, pageSize, filters, hiddenColumns, sortBy }, } = (0, react_table_1.useTable)({
        columns: getTransformedColumns,
        data: memoizedData,
        defaultColumn,
        autoResetPage: false,
        autoResetFilters: false,
        initialState: {
            pageSize: 100,
            hiddenColumns: initHiddenCols,
            sortBy: initSortBy
                ? Array.isArray(initSortBy)
                    ? initSortBy
                    : [initSortBy]
                : undefined,
            filters: initFilters ?? [],
        },
    }, react_table_1.useFilters, react_table_1.useSortBy, react_table_1.usePagination, react_table_1.useRowSelect, react_table_1.useFlexLayout, (hooks) => {
        showSelection &&
            hooks.visibleColumns.push((columns) => [
                {
                    id: 'selection',
                    width: (0, units_1.getRem)(3.25),
                    sticky: true,
                    Header: ({ getToggleAllRowsSelectedProps }) => (react_1.default.createElement(_ui_1.Checkbox, { type: 'interminate', ...getToggleAllRowsSelectedProps() })),
                    Cell: ({ row }) => (react_1.default.createElement(_ui_1.Checkbox, { type: 'interminate', ...row.getToggleRowSelectedProps() })),
                },
                ...columns,
            ]);
    });
    react_1.default.useEffect(() => {
        if ((0, util_1.isNotNull)(handleOnFilteredRows)) {
            handleOnFilteredRows(rows);
        }
    }, [data]);
    const dataSource = pagination ? page : rows;
    const shownColumns = !!allColumns
        .map((col) => col.id)
        .filter((col) => ![...hiddenColumns, 'selection', 'menu'].includes(col)).length;
    const handleHiddenColumns = (hidden) => {
        setHiddenColumns(hidden);
        if (!Object.keys(tablesConfig).includes(tableName) ||
            util_1.miscUtil.safeStringify(hidden) !==
                util_1.miscUtil.safeStringify(tablesConfig[tableName].hiddenColumns)) {
            setInitHiddenCols(hidden);
            // updateTablesConfig(tableName, { hiddenColumns: hidden })
            rememberTableUserConfig([['hiddenColumns', hidden]], true);
        }
    };
    const handleSortBy = () => {
        const newSortBy = sortBy?.length ? sortBy[0] : null;
        if (!Object.keys(tablesConfig).includes(tableName) ||
            util_1.miscUtil.safeStringify(newSortBy) !==
                util_1.miscUtil.safeStringify(tablesConfig[tableName].sortBy)) {
            setInitSortBy(newSortBy);
            // updateTablesConfig(tableName, { sortBy: newSortBy })
            rememberTableUserConfig([['sortBy', newSortBy]], true);
        }
    };
    const handleFilters = () => {
        const activeFilters = sanitizeFilters(filters ?? []);
        const persistedFilters = sanitizeFilters(activeFilters);
        setAllFilters(activeFilters);
        if (!hasCallerFilters)
            rememberTableUserConfig([['filters', persistedFilters]]);
    };
    (0, react_1.useEffect)(() => {
        handleSortBy();
    }, [util_1.miscUtil.safeStringify(sortBy)]);
    react_1.default.useEffect(() => {
        handleFilters();
    }, [util_1.miscUtil.safeStringify(filters)]);
    (0, react_1.useEffect)(() => {
        !!handleOnSelect && handleOnSelect(selectedFlatRows);
    }, [selectedFlatRows.length]);
    (0, react_1.useEffect)(() => {
        setTableData(dataSource);
        setRows([]);
    }, [dataSource]);
    const handleActionBarDettachment = () => {
        if (actionBarRef) {
            const oldParent = document.querySelector('.ds-table-detachable-node');
            if (!(0, util_1.isValue)(oldParent))
                return;
            while (oldParent.childNodes.length > 0) {
                if (actionBarRef) {
                    actionBarRef.current.appendChild(oldParent.childNodes[0]);
                }
                else {
                    defaultActionBarRef.current?.appendChild(oldParent.childNodes[0]);
                }
            }
        }
    };
    (0, react_1.useEffect)(() => {
        handleActionBarDettachment();
    }, []);
    const handleEditSave = async () => {
        try {
            const res = await onTableSave(editedRows);
            if (res) {
                setRows([]);
                util_1.notification.success({
                    message: 'SUCCESS_MESSAGE.editSaved',
                });
            }
        }
        catch (e) {
            console.log(e);
            util_1.notification.error({ message: 'ERR_MESSAGE.editFailed' });
        }
    };
    const handleFooterDataSource = () => {
        if (extraRow &&
            tableData.length &&
            tableConfig.some((el) => !!el.extraRowToHTML)) {
            return [{ ...tableData[tableData.length - 1] }];
        }
        return [];
    };
    // const setInitFilters = () =>
    //   setAllFilters(
    //     filters.filter((filter) => !(filter.value === null || filter.value === ''))
    //   )
    const showDataLoader = isLoading || loadingData;
    // React.useEffect(() => { setAllFilters(initialColumnFilters) }, [initialColumnFilters])
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('table-wrapper', type, size, {
            'empty-header': !!actionBarRef && !extraContent && !editedRows.length && !showDataLoader,
        }) },
        (extraContent || !!actionBarRef || !!editedRows.length || showDataLoader) && (react_1.default.createElement("div", { className: 'table-header' },
            extraContent,
            react_1.default.createElement("div", { ref: defaultActionBarRef }),
            showDataLoader && (react_1.default.createElement("div", { className: 'data-loader' },
                react_1.default.createElement(_ui_1.Alert, { text: (0, util_1.t)('LOADING_DATA'), customIco: _ui_1.Icon.ICONS.loader, size: _ui_1.Alert.SIZES.FULL_WIDTH, type: _ui_1.Alert.TYPES.INFO }))),
            react_1.default.createElement(components_1.ActionBar, { showActionBar: showActionBar, editedRows: editedRows, extraButtonContent: extraButtonContent, allColumns: allColumns, hiddenColumns: hiddenColumns, setHiddenColumns: handleHiddenColumns, exportHidden: exportHidden, exportFileName: exportFileName, tableName: tableName, selectedFlatRows: selectedFlatRows, getTransformedColumns: getTransformedColumns, onBatchActions: onBatchActions, batchActionsDisabled: batchActionsDisabled, showConfig: showConfig, filters: filters, setAllFilters: setAllFilters }),
            !!editedRows.length && (react_1.default.createElement(_ui_1.EditInfoPanel, { onSave: handleEditSave, onCancel: () => setRows([]), count: editedRows.length, isDisabled: handleDisabledSubmit === null
                    ? false
                    : handleDisabledSubmit(editedRows, data), savingLoading: savingLoading })))),
        extraContentRow && react_1.default.createElement("div", { className: 'extra-content-row' }, extraContentRow),
        shownColumns ? (react_1.default.createElement("div", { ref: tableRef, onScroll: (e) => (0, helpers_1.handleScrollShadows)(e, tableRef), className: (0, classnames_1.default)('table-new', `table-${tableName}`, className, size, {
                bordered,
            }), ...getTableProps(), style: maxHeight ? { maxHeight } : undefined },
            isLoading && react_1.default.createElement(components_1.LoadingTable, { withHead: true }),
            !isLoading && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(components_1.TableHead, { headerGroups: headerGroups }),
                tableData && !!tableData.length && (react_1.default.createElement(components_1.TableBody, { rowOnMouseLeave: rowOnMouseLeave, prepareRow: prepareRow, tableRowConfig: tableRowConfig, tableData: tableData, setRows: setRows, editedRows: editedRows, getTableBodyProps: getTableProps })),
                extraRow && !!tableData?.length && (react_1.default.createElement(components_1.TableFooter, { dataSource: handleFooterDataSource(), prepareRow: prepareRow, rowOnMouseLeave: rowOnMouseLeave, extraRow: extraRow })),
                loadingData && !tableData?.length && react_1.default.createElement(components_1.LoadingTable, null),
                !loadingData && tableData && !tableData.length && (react_1.default.createElement(components_1.NoData, { customNoDataText: customNoDataText })))))) : (react_1.default.createElement(components_1.NoColumns, null)),
        react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.VERTICAL, size: _ui_1.Spacing.SIZES.SIZE_14 }),
        react_1.default.createElement(_ui_1.Flex, { justify: _ui_1.Flex.POSITION.SPC_BETWEEN },
            pagination && (react_1.default.createElement(components_1.Pagination, { gotoPage: gotoPage, canPreviousPage: canPreviousPage, previousPage: previousPage, nextPage: nextPage, canNextPage: canNextPage, pageCount: pageCount, pageIndex: pageIndex, pageOptions: pageOptions, pageSize: pageSize, setPageSize: setPageSize, itemsCount: rows.length })),
            paginationRowExtra || false)));
};
exports.Table = Table;
// Table.propTypes = {
//   initialHiddenColumns: PropTypes.arrayOf(PropTypes.string),
//   initialSortBy: PropTypes.arrayOf(
//     PropTypes.shape({
//       id: PropTypes.string,
//       desc: PropTypes.bool,
//     })
//   ),
//   initialColumnFilters: PropTypes.arrayOf(
//     PropTypes.shape({
//       id: PropTypes.string,
//       value: PropTypes.oneOfType([
//         PropTypes.string,
//         PropTypes.number,
//         PropTypes.bool,
//         PropTypes.array,
//       ]),
//     })
//   ),
//   showActionBar: PropTypes.bool,
//   showConfig: PropTypes.bool,
//   showSelection: PropTypes.bool,
//   extraButtonContent: PropTypes.node,
//   extraContent: PropTypes.node,
//   extraContentRow: PropTypes.node,
//   paginationRowExtra: PropTypes.node,
//   rows: PropTypes.array.isRequired,
//   pagination: PropTypes.bool,
//   tableName: PropTypes.string.isRequired,
//   tableConfig: PropTypes.arrayOf(
//     PropTypes.shape({
//       key: PropTypes.string,
//     })
//   ),
//   isLoading: PropTypes.bool,
//   loadingData: PropTypes.bool,
//   dataReloading: PropTypes.bool,
//   exportHidden: PropTypes.bool,
//   exportFileName: PropTypes.string,
//   className: PropTypes.string,
//   customNoDataText: PropTypes.string,
//   handleOnSelect: PropTypes.func,
//   handleDisabledSubmit: PropTypes.func,
//   handleOnFilteredRows: PropTypes.func,
//   onTableSave: PropTypes.func,
//   onBatchActions: PropTypes.func,
//   batchActionsDisabled: PropTypes.bool,
//   bordered: PropTypes.bool,
//   size: PropTypes.string,
//   extraRow: PropTypes.bool,
//   type: PropTypes.string,
//   maxHeight: PropTypes.string,
// }
exports.Table.defaultProps = {
    rows: [],
    initialSortBy: [],
    initialColumnFilters: [],
    initialHiddenColumns: [],
    showActionBar: true,
    showSelection: true,
    showConfig: true,
    extraButtonContent: null,
    extraContent: null,
    extraContentRow: null,
    paginationRowExtra: null,
    className: '',
    isLoading: false,
    loadingData: false,
    exportHidden: false,
    exportFileName: null,
    customNoDataText: null,
    bordered: false,
    handleOnSelect: null,
    handleDisabledSubmit: null,
    handleOnFilteredRows: null,
    pagination: true,
    onTableSave: () => null,
    onBatchActions: null,
    batchActionsDisabled: false,
    size: SIZE.REGULAR,
    extraRow: false,
    type: TYPES.FILL,
    maxHeight: '',
    rowOnMouseLeave: null,
    actionBarRef: null,
    savingLoading: false,
};
exports.Table.SIZE = SIZE;
exports.Table.TYPES = TYPES;
exports.default = exports.Table;
